__webpack_require__.p = "/media/inpulse-template-ac-new-a/";